import axios from "@/http";
import { handleGetRequestParams } from '@/common/js/util'

class NotVerifiedProject {
  /* 未核实项目列表 */
  static getNotVerifiedProjectList(option) {
    let url = `/oa/api/bill/not/check/bill/date/list?`;
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default NotVerifiedProject